// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"cd30b277","251":"8309869d","261":"be72bd34","340":"be44a97b","643":"b48882fb","712":"5dc94253","843":"125f26df"}[chunkId] + ".chunk.js";
};